module.exports = __webpack_public_path__ + "h5/img/live-logo.56163a7b.gif";